import { h } from 'preact';
import React from 'react';

import * as components from '../../Components/noticeComponents';
import { DefaultLanguageContext, RefetchStacksContext } from '../../contexts';

import { convertClassName } from '../../util';

const Children = (props) => {
  return props.components.map((component, index) => {
    const CustomComponent = components[component.type];
    const path = [...props.path];
    path.push(index);

    return (
      <DefaultLanguageContext.Consumer>
        {(defaultLanguage) => (
          <RefetchStacksContext.Consumer>
            {(refetchStacks) => (
              <CustomComponent
                path={path}
                dev={props.dev}
                key={'n-' + path}
                component={component}
                className={convertClassName(component.handle)}
                siteId={props.siteId}
                message={props.message}
                makeChoice={props.makeChoice}
                updateStacks={props.updateStacks}
                consentUUID={props.consentUUID}
                language={props.language}
                cmpv2Origin={props.cmpv2Origin}
                width={props.width}
                events={props.events}
                preview={props.preview}
                preloadMsg={props.preloadMsg}
                stacksData={props.stacksData}
                refetchStacks={refetchStacks}
                defaultLanguage={defaultLanguage}
              />
            )}
          </RefetchStacksContext.Consumer>
        )}
      </DefaultLanguageContext.Consumer>
    );
  });
}

export default Children;